import { getAdapter } from '../../adapters/AdapterManager';
import CommonAdapter from '../../adapters/CommonAdapter';
import { ApiMethodCallback } from '../ApiMethod';
import { createSuccessResult } from '../ApiMethodResponseCreator';
import { getExtensibilityContext } from 'owa-addins-store';
import {
    ApiSharedProperties,
    DelegatePermissions,
    DelegatePermissionsBitMapValues,
} from './SharedProperties';

export default function getSharedPropertiesAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: any,
    callback: ApiMethodCallback
) {
    const adapter: CommonAdapter = getAdapter(hostItemIndex) as CommonAdapter;
    const adapterSharedProperties = adapter.getSharedProperties();

    const delegatePermissions = getDelegatePermissionsBitMap(
        adapterSharedProperties.delegatePermissions
    );

    const apiSharedProperties: ApiSharedProperties = {
        delegatePermissions: delegatePermissions,
        owner: adapterSharedProperties.owner,
        restUrl: getExtensibilityContext().RestUrl,
    };

    callback(createSuccessResult(apiSharedProperties));
}

function getDelegatePermissionsBitMap(permissions: DelegatePermissions): number {
    let permissionsBitMap = 0;

    if (permissions.Read) {
        permissionsBitMap += DelegatePermissionsBitMapValues.Read;
    }

    if (permissions.Create) {
        permissionsBitMap += DelegatePermissionsBitMapValues.Create;
    }

    if (permissions.DeleteOwn) {
        permissionsBitMap += DelegatePermissionsBitMapValues.DeleteOwn;
    }

    if (permissions.DeleteAll) {
        permissionsBitMap += DelegatePermissionsBitMapValues.DeleteAll;
    }

    if (permissions.EditOwn) {
        permissionsBitMap += DelegatePermissionsBitMapValues.EditOwn;
    }

    if (permissions.EditAll) {
        permissionsBitMap += DelegatePermissionsBitMapValues.EditAll;
    }

    return permissionsBitMap;
}
